export default __webpack_public_path__ + "static/bofaktablad_smedjan-8d1983d36e900df154a72c44bd4b476d.pdf";